'use client';

import { type ReactNode } from 'react';
import { isPlainRecord } from '@terra/shared-dto-chat-types';
import type { CardRenderContext } from '../../tool-config-types';
import { getPortalToolDisplayConfig } from '../portal/portal-tool-display-config';
import { TRACK_HISTORY_REQUEST_TOOL_NAME } from '@terra/shared-dto-chat-types';
import { getHITLLeadingHeaderActions } from '../shared/hitl-artifact-header-actions';
import { TrackHistoryRequestHttpView } from './track-history-request-http-view';

function readToolInput(input: unknown): Record<string, unknown> {
  if (!isPlainRecord(input)) {
    return {};
  }

  return input;
}

export function renderTrackHistoryRequestCard(
  ctx: CardRenderContext,
): ReactNode {
  const displayConfig = getPortalToolDisplayConfig(
    TRACK_HISTORY_REQUEST_TOOL_NAME,
  );
  const isRunning =
    ctx.toolCallData.status === 'started' ||
    ctx.toolCallData.status === 'in-progress';
  const isHitlPending = Boolean(ctx.headerActions && !ctx.hitlDecisionType);
  const output = ctx.toolCallData.output;
  const isTracked =
    isPlainRecord(output) &&
    isPlainRecord(output.data) &&
    output.data.tracked === true;

  return (
    <TrackHistoryRequestHttpView
      input={readToolInput(ctx.toolCallData.input)}
      showReviewMessage={isHitlPending}
      isRunning={isRunning && !isHitlPending && !isTracked}
      isTracked={isTracked}
      runningText={displayConfig?.runningText}
      headerActions={getHITLLeadingHeaderActions({
        hitlDecisionType: ctx.hitlDecisionType,
        headerActions: ctx.headerActions,
      })}
    />
  );
}
